import { createAction, props } from '@ngrx/store';
import { PdfExportDomain, ReportDomain } from '@mode/shared/contract-common';

export const createPdfExport = createAction(
  '[Platform Header] Create PDF Export',
  props<{ reportRunToken: string; showDialog: boolean }>()
);

export const createPdfExportSubmitted = createAction(
  '[Platform Header] Create PDF Export Submitted',
  props<{ reportRunToken: string; showDialog: boolean }>()
);

export const createPdfExportSuccess = createAction(
  '[Platform Header] Create PDF Export success ',
  props<{ pdfExport: PdfExportDomain.PdfExportComplete }>()
);

export const createPdfExportFailed = createAction(
  '[Platform Header] Create PDF Export failed ',
  props<{ state?: PdfExportDomain.PdfExportState; error: Error; showDialog?: boolean }>()
);

export const openPdfExportDialog = createAction(
  '[Platform Header] Open PDF Export dialog',
  props<{ report: ReportDomain.Report }>()
);
